<template>
  <StaffActivePageTableControl></StaffActivePageTableControl>
</template>

<script>
import StaffActivePageTableControl from "@/modules/school/components/staff/filter/StaffActivePageTableControl";
export default {
  name: "SchoolStaffAwayControl",
  components: { StaffActivePageTableControl },
};
</script>

<style scoped></style>
